import { BaseModel } from '../base-model';
import { IGenericObject } from '../common';

export interface IChildListing {
  ItemState?: number;
}

export interface IPropertyMultModel extends IChildListing {
  Id?: number
  FieldType?: number;
  FieldId?: number;
  IsMain?: boolean;
  FieldInfo?: IGenericObject;
  PropertyId?:number

}
export class PropertyMultModel extends BaseModel<IPropertyMultModel> implements IPropertyMultModel {
  Id?: number
  FieldType: number;
  FieldId: number;
  IsMain: boolean;
  FieldInfo: IGenericObject;
  ItemState: number;
  PropertyId?:number
  /**
   *
   */
  constructor(option?: IPropertyMultModel) {
    super(option);

  }
}